module.exports = __webpack_public_path__ + "static/media/esri.90dd750f.png";